import React, { useState, useEffect } from 'react';
import './Testimonials.css';

const testimonials = [
  {
    id: 1,
    name: 'Rahul Sharma',
    role: 'Business Owner',
    company: 'RS Enterprises',
    review: 'Deepak created an outstanding brand identity for our company. His attention to detail and creative approach exceeded our expectations. The logo and branding kit he delivered was exactly what we needed.',
    rating: 5,
    avatar: 'RS',
    color: '#e63946',
    tag: 'Branding',
  },
  {
    id: 2,
    name: 'Priya Mehta',
    role: 'Marketing Manager',
    company: 'Digital Agency',
    review: 'Working with Deepak was a fantastic experience. He designed our entire social media campaign creatives with a consistent and professional look. Our engagement increased significantly after his work.',
    rating: 5,
    avatar: 'PM',
    color: '#A259FF',
    tag: 'Social Media',
  },
  {
    id: 3,
    name: 'Amit Verma',
    role: 'Startup Founder',
    company: 'TechStart India',
    review: 'Deepak delivered our complete branding package on time and within budget. His communication was excellent throughout the project. I highly recommend him for any graphic design work.',
    rating: 5,
    avatar: 'AV',
    color: '#00C4CC',
    tag: 'Logo Design',
  },
  {
    id: 4,
    name: 'Sunita Kapoor',
    role: 'Restaurant Owner',
    company: 'Kapoor Kitchen',
    review: 'The menu design and promotional posters Deepak created for our restaurant were absolutely stunning. Our customers frequently compliment the professional look of our branding materials.',
    rating: 5,
    avatar: 'SK',
    color: '#FF9A00',
    tag: 'Print Design',
  },
  {
    id: 5,
    name: 'Vikram Singh',
    role: 'E-commerce Owner',
    company: 'ShopEasy',
    review: 'Deepak redesigned our product packaging and it made a huge difference in our sales. His creativity and understanding of brand identity is exceptional. Will definitely work with him again.',
    rating: 5,
    avatar: 'VS',
    color: '#00A550',
    tag: 'Packaging',
  },
];

const Testimonials = () => {
  const [active, setActive] = useState(0);
  const [animating, setAnimating] = useState(false);

  const goTo = (idx) => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setActive(idx);
      setAnimating(false);
    }, 300);
  };

  const prev = () => goTo((active - 1 + testimonials.length) % testimonials.length);
  const next = () => goTo((active + 1) % testimonials.length);

useEffect(() => {
  const timer = setInterval(() => {
    next();
  }, 5000);

  return () => clearInterval(timer);
}, [active, next]);
  const t = testimonials[active];

  return (
    <section className="testi" id="testimonials">

      {/* BG ELEMENTS */}
      <div className="testi-bg-word">REVIEWS</div>
      <div className="testi-glow" style={{ background: `radial-gradient(circle, ${t.color}15 0%, transparent 65%)` }}></div>

      {/* HEADING */}
      <div className="testi-heading" data-aos="fade-up">
        <div className="testi-heading-top">
          <span className="th-line"></span>
          <span className="th-tag">What Clients Say</span>
          <span className="th-line"></span>
        </div>
        <h2 className="th-title">Client <span>Reviews</span></h2>
      </div>

      {/* MAIN LAYOUT */}
      <div className="testi-layout" data-aos="fade-up" data-aos-delay="150">

        {/* LEFT — CLIENT LIST */}
        <div className="testi-list">
          {testimonials.map((item, i) => (
            <div
              key={item.id}
              className={`tl-item ${i === active ? 'active' : ''}`}
              onClick={() => goTo(i)}
              style={{ '--tc': item.color }}
            >
              <div className="tl-avatar" style={{ background: i === active ? item.color : '#111' }}>
                {item.avatar}
              </div>
              <div className="tl-info">
                <span className="tl-name">{item.name}</span>
                <span className="tl-role">{item.role}</span>
              </div>
              <div className="tl-tag">{item.tag}</div>
            </div>
          ))}
        </div>

        {/* RIGHT — MAIN REVIEW */}
        <div className={`testi-main ${animating ? 'fade-out' : 'fade-in'}`}>

          {/* TOP ROW */}
          <div className="tm-top">
            <div className="tm-avatar-wrap">
              <div className="tm-avatar" style={{ background: t.color }}>
                {t.avatar}
              </div>
              <div className="tm-avatar-ring" style={{ borderColor: t.color }}></div>
            </div>
            <div className="tm-person">
              <h3 className="tm-name">{t.name}</h3>
              <p className="tm-role">{t.role} · <span style={{ color: t.color }}>{t.company}</span></p>
              <div className="tm-stars">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="tm-star" style={{ color: i < t.rating ? '#FFD700' : '#222' }}>★</span>
                ))}
              </div>
            </div>
            <div className="tm-tag-badge" style={{ borderColor: t.color, color: t.color }}>
              {t.tag}
            </div>
          </div>

          {/* QUOTE */}
          <div className="tm-quote-wrap">
            <div className="tm-quote-mark" style={{ color: t.color }}>"</div>
            <p className="tm-review">{t.review}</p>
          </div>

          {/* BOTTOM */}
          <div className="tm-bottom">
            <div className="tm-progress-bar">
              <div
                className="tm-progress-fill"
                style={{
                  width: `${((active + 1) / testimonials.length) * 100}%`,
                  background: t.color
                }}
              ></div>
            </div>
            <div className="tm-nav">
              <button className="tm-btn" onClick={prev}>←</button>
              <span className="tm-count">
                <strong style={{ color: t.color }}>{String(active + 1).padStart(2, '0')}</strong>
                <span> / {String(testimonials.length).padStart(2, '0')}</span>
              </span>
              <button className="tm-btn" onClick={next}>→</button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Testimonials;